import labels from './labels';

export const FX_ACCOUNT_PASSWORD_UPDATE_SUCCESS = `${labels.FX_ACCOUNT} password is updated successfully.`;
export const FX_ACCOUNT_PASSWORD_UPDATE_FAILED = `${labels.FX_ACCOUNT} password update has either failed or declined.`;
export const FX_ACCOUNT_PASSWORD_UPDATE_PARTIAL = `${labels.FX_ACCOUNT} is partially updated.`;

export const FX_ACCOUNT_ACTIVATION_SUCCESS = `${labels.FX_ACCOUNT} is activated successfully.`;
export const FX_ACCOUNT_ACTIVATION_FAILED = `${labels.FX_ACCOUNT} activation has either failed or declined.`;
export const FX_ACCOUNT_ACTIVATION_PARTIAL = `${labels.FX_ACCOUNT} activation is not completed`;

export const UPDATE_CONTACT_SUCCESS = 'Contact information updated successfully';
export const UPDATE_CONTACT_FAILED = 'Contact information update has either failed or declined. Try again by clicking the call to action below.';
